import React from 'react';
import { Button } from 'antd';

import './VncClient.scss';

const ACTION_BAR_JOB_ID = 'Job ID:';
const ACTION_BAR_SERVER = 'Server:';
const DISCONNECT_MODAL_TITLE = 'Disconnect';

const ActionBar = (props) => {
	return (
		<div className="action-bar">
			<div className="action-bar-element">{props.getClipboard()}</div>
			<div className="action-bar-element">{props.alternativeVNC()}</div>
			<div className="action-bar-element">
				{ACTION_BAR_JOB_ID} {props.jobid}
			</div>
			<div className="action-bar-element">
				{ACTION_BAR_SERVER} {props.server}:{props.port}
			</div>
			<div className="action-bar-element">
				<Button className="disconnect-btn" onClick={() => props.showModal(true)}>
					{DISCONNECT_MODAL_TITLE}
				</Button>
			</div>
		</div>
	);
};

export default ActionBar;
